import {gql} from '@apollo/client';

import {
  InAppNotificationListingQuery as InAppNotificationListingQueryData,
  InAppNotificationListingQueryVariables,
} from './__generated/InAppNotificationListingQuery';
import {InAppNotificationUnreadSummaryQuery as InAppNotificationUnreadSummaryQueryData} from './__generated/InAppNotificationUnreadSummaryQuery';
import {
  UpdateInAppNotificationsMutation as UpdateInAppNotificationsMutationData,
  UpdateInAppNotificationsMutationVariables,
} from './__generated/UpdateInAppNotificationsMutation';

// The types above are generated from the `gql` documents in this file by `dev generate frontend`.
// These documents are the source codegen reads; edit them here and regenerate to update the types.
export type {
  InAppNotificationListingQueryData,
  InAppNotificationListingQueryVariables,
  InAppNotificationUnreadSummaryQueryData,
  UpdateInAppNotificationsMutationData,
  UpdateInAppNotificationsMutationVariables,
};

// One notification as returned by `inAppNotificationListing`. Selects every field on
// `InAppNotificationNode`; `resourceApiId`/`actorApiId` are fetched for future link derivation even
// though V1 renders the body as plain text.
export const IN_APP_NOTIFICATION_FRAGMENT = gql`
  fragment InAppNotificationFields on InAppNotificationNode {
    id
    status
    title
    body
    actorApiId
    resourceApiId
    lastEventAt
    readAt
    dismissedAt
  }
`;

export const IN_APP_NOTIFICATION_LISTING_QUERY = gql`
  query InAppNotificationListingQuery(
    $pageSize: StrictInt
    $nextToken: StrictString
    $statuses: [InAppNotificationStatus!]
  ) @skipAudit @engComponent(name: NOTIFICATIONS) {
    inAppNotificationListing(pageSize: $pageSize, nextToken: $nextToken, statuses: $statuses) {
      items {
        ...InAppNotificationFields
      }
      nextToken
    }
  }
  ${IN_APP_NOTIFICATION_FRAGMENT}
`;

export const IN_APP_NOTIFICATION_UNREAD_SUMMARY_QUERY = gql`
  query InAppNotificationUnreadSummaryQuery @skipAudit @engComponent(name: NOTIFICATIONS) {
    inAppNotificationUnreadSummary {
      unreadCount
      latestEventAt
    }
  }
`;

// Bulk status transitions for the acting user's notifications (mark read, mark all read, dismiss).
// The returned nodes select the full fragment so Apollo's normalized cache merges each row's new
// `status` by `id` on its own, without the client hand-writing the cache. `unreadSummary` selects the
// same fields as the summary query; its type is a cache singleton (see `typePolicies`), so the badge
// updates from this response too.
//
// Keep in sync with `_UPDATE_MUTATION` in
// tests/unit/notifications/network/graphql/in_app_notification_graphql_resolvers_test.py, which
// mirrors this document (including its `@audit` and `@engComponent` directives) to test the resolver.
export const UPDATE_IN_APP_NOTIFICATIONS_MUTATION = gql`
  mutation UpdateInAppNotificationsMutation($updates: [UpdateInAppNotificationInputType!]!)
  @engComponent(name: NOTIFICATIONS) {
    updateInAppNotifications(updates: $updates)
      @audit(msg: "Updated in-app notifications", context: "Updated in-app notifications") {
      items {
        ...InAppNotificationFields
      }
      unreadSummary {
        unreadCount
        latestEventAt
      }
    }
  }
  ${IN_APP_NOTIFICATION_FRAGMENT}
`;
